import { v4 as uuidv4 } from 'uuid';

function toggleIndustryFilter(category) {
    const current = this.search.industryFilters;
    const exists = current.includes(category);
    this.search.industryFilters = exists
        ? current.filter((c) => c !== category)
        : [...current, category];
    this.observed.search = uuidv4();
    this.applyDirectoryFilter();
}

export default toggleIndustryFilter;
